import { h, render } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import clsx from 'clsx';
import ProductGallery from './product-gallery';
// eslint-disable-next-line import/no-named-as-default
import ProductForm from './product-form';
import {
  getProductsByTag,
  decodeId,
  getProductByHandle
} from '../utils/storefront/get-products';

export default (element, data) => {
  const Product = (props) => {
    const initialProduct = props?.data?.products
      ? props?.data?.products?.nodes?.find(
          (v) => decodeId(v.id, 'Product') === props.id,
        )
      : props?.data?.productByHandle;


      useEffect(() => {
        if (document.querySelector('.not-loaded')) {
          document
            .querySelector('[data-section="product"]')
            .classList.remove('not-loaded');
        }
      }, []);

    const initialVariant = initialProduct?.variants?.edges[0]?.node;
    const [currentProduct, setCurrentProduct] = useState(initialProduct);
    const [currentVariant, setCurrentVariant] = useState(initialVariant);
    
    const sizesOptions = props?.data?.products?.nodes?.map(
      (p) => p.sizeOption?.value,
    );

    return (
      <div
        className={clsx(
          'flex flex-col laptop:!grid grid-cols-12 laptop:items-start',
          props.customClass,
        )}
      >
        <ProductGallery
          currentProduct={currentProduct}
          customClass="col-span-7 laptop:pr-[26px]"
        />
        <ProductForm
          currentProduct={currentProduct}
          currentVariant={currentVariant}
          allProducts={props}
          sizesOptions={sizesOptions}
          setCurrentProduct={setCurrentProduct}
          setCurrentVariant={setCurrentVariant}
          customClass="col-span-5 pt-5 laptop:pt-10 desktop:pl-[83px] desktop:pr-[80px] laptop:pr-5 laptop:pl-5"
        />
      </div>
    );
  };

  const init = async () => {
    const products = data.group_tag
      ? await getProductsByTag(data.group_tag)
      : await getProductByHandle(data.handle);

    const globalTemplate = JSON.parse(
      document.querySelector('[data-global-data]').textContent,
    );

    const dataWithProducts = {
      ...data,
      ...products,
      ...globalTemplate,
    };
    render(
      <Product {...dataWithProducts} customClass="max-w-[1440px] mx-auto" />,
      element,
    );
  };

  init();
  
};
